(function () {
    'use strict';

    angular
        .module('app.tenants')
        .controller('TenantReportsController', TenantReportsController);

    TenantReportsController.$inject = ['common', 'dataservice', 'Excel'];
    /* @ngInject */
    function TenantReportsController(common, dataservice, excel) {
        var vm = this;
        vm.title = 'Tenant Reports';
        vm.displayedItems = [];
        vm.items = [];
        vm.reportTypes = [];
        vm.reportType = '';
        vm.generate = generate;
        vm.exportToExcel = exportToExcel;
        vm.reportData = {};

        vm.TotalItems = 0;
        vm.TotalItems1 = 0;
        vm.TotalItems2 = 0;
        vm.TotalItems3 = 0;
        vm.TotalItems4 = 0;
        vm.TotalItems5 = 0;
        vm.TotalItems6 = 0;
        vm.TotalItems7 = 0;
        vm.TotalItems8 = 0;

        activate();

        function activate() {
            var promises = [common.checkIsAdmin(), loadReportTypes()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
            }, function (error) { });
        }

        function loadReportTypes() {
            vm.reportTypes.push({ Action: 'Count/BookingCompletions', Description: 'Booking Completions' });
            vm.reportTypes.push({ Action: 'Count/TaskCompletions', Description: 'Task Completions' });
            vm.reportTypes.push({ Action: 'Count/BookingNotes', Description: 'Booking Notes' });
            vm.reportTypes.push({ Action: 'Count/TaskNotes', Description: 'Task Notes' });
            vm.reportTypes.push({ Action: 'Count/Alerts', Description: 'Alerts' });
            vm.reportTypes.push({ Action: 'Count/LogEntries', Description: 'Log Entries' });
            vm.reportTypes.push({ Action: 'Count/Users', Description: 'Users' });
            vm.reportTypes.push({ Action: 'Count/Attachments', Description: 'Attachments' });
            vm.reportTypes.push({ Action: 'Count/Tasks', Description: 'Tasks' });
            vm.reportTypes.push({ Action: 'Count/FloorPlans', Description: 'Floor Plans' });
            vm.reportTypes.push({ Action: 'Count/EventDisplays', Description: 'Event Displays' });
            vm.reportTypes.push({ Action: 'Count/PaymentTemplates', Description: 'Payment Templates' });
            vm.reportTypes.sort(_reportTypeSorter);
        }
        function _reportTypeSorter(a, b) {
            if (a.Description < b.Description) {
                return -1;
            }
            if (a.Description > b.Description) {
                return 1;
            }
            return 0;
        }

        function exportToExcel(id) {
            var clonedTable = $(id).clone(true);
            var fileName = "unfound";
            for (var i = 0; i < vm.reportTypes.length; i++) {
                if (vm.reportTypes[i].Action == vm.reportType) {
                    fileName = vm.reportTypes[i].Description;
                    break;
                }
            }

            excel.downloadExcel(id, fileName + '.csv', clonedTable.html());

        }

        function generate() {
            return dataservice.getItems('api/TenantReports/' + vm.reportType).then(function (response) {
                vm.TotalItems = 0;
                vm.TotalItems1 = 0;
                vm.TotalItems2 = 0;
                vm.TotalItems3 = 0;
                vm.TotalItems4 = 0;
                vm.TotalItems5 = 0;
                vm.TotalItems6 = 0;
                vm.TotalItems7 = 0;
                vm.TotalItems8 = 0;
                vm.reportData = response.data;
                vm.items = vm.reportData.Data;
                vm.displayedItems = [].concat(vm.items);

                for (var i = 0; i < vm.displayedItems.length; i++) {
                    var onItem = vm.displayedItems[i];
                    vm.TotalItems += onItem.NumberOfItems;
                    vm.TotalItems1 += onItem.NumberOfItems1;
                    vm.TotalItems2 += onItem.NumberOfItems2;
                    vm.TotalItems3 += onItem.NumberOfItems3;
                    vm.TotalItems4 += onItem.NumberOfItems4;
                    vm.TotalItems5 += onItem.NumberOfItems5;
                    vm.TotalItems6 += onItem.NumberOfItems6;
                    vm.TotalItems7 += onItem.NumberOfItems7;
                    vm.TotalItems8 += onItem.NumberOfItems8;
                }

            }, function (error) { });
        }
       
    }
})();
